import React from "react";
import get from "lodash/get";

import CommonRow from "../common-row";
import CollectionHeading from "../../atoms/collection-heading";

const SixStories1WidgetWithPoll = ({ collection }) => {
  const showCollectionName = get(collection, ["associated-metadata", "show_collection_name_website"], null);
  const subCollection =
    collection.items && collection.items.length > 0 && collection.items.find(item => item.type === "collection");

  if (!subCollection) {
    return null;
  }

  return (
    <>
      {showCollectionName && <CollectionHeading collection={collection} />}
      <CommonRow collection={subCollection} showHeadingName={false} />
    </>
  );
};

export default SixStories1WidgetWithPoll;
